(function() {
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookieOnRootDomain(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

    const hostParts = window.location.hostname.split('.');
    const rootDomain = '.' + hostParts.slice(-2).join('.');

    document.cookie = [
      name + '=' + encodeURIComponent(value),
      'domain=' + rootDomain,
      'path=/',
      'expires=' + expires.toUTCString(),
      'SameSite=Lax'
    ].join('; ');
  }

  // --- Config ---
  const COOKIES = [
    { name: 'bgaffilite_id',  days: 30 },
    { name: 'bgcart', days: 7  },
    { name: 'bgclick_id',  days: 90 },
    { name: 'bgexpire_time',  days: 90 },
    { name: 'bglast_click',  days: 90 },
    { name: 'bgvisitor_id',  days: 90 },
    // Add as many as you need...
  ];

  COOKIES.forEach(function(cookie) {
    const value = getCookie(cookie.name);
    if (value !== null) {
      setCookieOnRootDomain(cookie.name, value, cookie.days);
    }
  });
})();




(function () {
  // Do nothing if there are no URL parameters — let Shopify's native geo-redirect handle it
  if (!window.location.search) return;

  var EU_COUNTRIES = [
    'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU',
    'IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE'
  ];

  var UK_COUNTRIES = [
    'GB',  // United Kingdom
    'JE',  // Jersey
    'GG',  // Guernsey
    'IM'   // Isle of Man
  ];

  var MARKET_HOSTS = {
    us:  'store.weightliftinghouse.com',
    eu:  'eustore.weightliftinghouse.com',
    uk:  'ukstore.weightliftinghouse.com',
    row: 'row.weightliftinghouse.com'
  };

  var CACHE_KEY = 'wlh_geo_country';

  function redirect(country) {
    country = country.toUpperCase();

    var targetHost;
    if (country === 'US') {
      targetHost = MARKET_HOSTS.us;
    } else if (EU_COUNTRIES.indexOf(country) !== -1) {
      targetHost = MARKET_HOSTS.eu;
    } else if (UK_COUNTRIES.indexOf(country) !== -1) {
      targetHost = MARKET_HOSTS.uk;
    } else {
      targetHost = MARKET_HOSTS.row;
    }

    if (targetHost === window.location.hostname) return;

    var url = new URL(window.location.href);
    url.hostname = targetHost;
    window.location.replace(url.toString());
  }

  // If country is explicitly set via URL param, trust it directly
  var params = new URLSearchParams(window.location.search);
  var countryParam = params.get('country');

  if (countryParam) {
    var country = countryParam.toUpperCase();
    sessionStorage.setItem(CACHE_KEY, country);
    redirect(country);
    return;
  }

  // Use cached country if available
  var cached = sessionStorage.getItem(CACHE_KEY);
  if (cached) {
    redirect(cached);
    return;
  }

  // No cache — fetch and store
  fetch('/browsing_context_suggestions.json')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var country = (
        data &&
        data.detected_values &&
        data.detected_values.country &&
        data.detected_values.country.handle
      ) || '';

      if (country) sessionStorage.setItem(CACHE_KEY, country.toUpperCase());
      redirect(country);
    })
    .catch(function () {});
})();